import type { FC } from "react"

import styles from "./UsageStartDateTab.module.scss"

import {
	type FragmentType,
	getFragmentData,
	graphql,
} from "@/souhl_admin/gql/__generated__"

export const usageStartDateTableRowFragment = graphql(/* GraphQL */ `
	fragment UsageStartDateTableRow on Salon {
		id
		displayName
		usageStartDate
	}
`)

type Props = {
	fragment: readonly FragmentType<typeof usageStartDateTableRowFragment>[]
	selected: Record<number, boolean>
	onToggle: (salonId: number, checked: boolean) => void
	onToggleAll: (checked: boolean) => void
}

const UsageStartDateTable: FC<Props> = ({
	fragment,
	selected,
	onToggle,
	onToggleAll,
}) => {
	const salons = getFragmentData(usageStartDateTableRowFragment, fragment)
	const allChecked = salons.length > 0 && salons.every((s) => selected[s.id])

	return (
		<div className={styles.table_wrapper}>
			<table className={styles.table}>
				<thead>
					<tr className={styles.header_row}>
						<th className={styles.th_checkbox}>
							<input
								type="checkbox"
								checked={allChecked}
								onChange={(e) => onToggleAll(e.target.checked)}
								aria-label="全選択"
							/>
						</th>
						<th>店舗名</th>
						<th className={styles.th_date}>利用開始日</th>
					</tr>
				</thead>
				<tbody>
					{salons.map((salon) => (
						<tr key={salon.id} className={styles.row}>
							<td className={styles.td_checkbox}>
								<input
									type="checkbox"
									checked={!!selected[salon.id]}
									onChange={(e) => onToggle(salon.id, e.target.checked)}
									aria-label={`選択: ${salon.displayName}`}
									data-testid={`usage-start-date-select-${salon.id}`}
								/>
							</td>
							<td>{salon.displayName}</td>
							<td>{salon.usageStartDate ?? "-"}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}

export default UsageStartDateTable
